// extracted by mini-css-extract-plugin
module.exports = {"figure":"Video_figure__7wpqN","iframeContainer":"Video_iframeContainer__yU_iR","videoDisabled":"Video_videoDisabled__lpVaR"};